import { useState } from 'react';

const useActionInput = ({ activeCommand }) => {
  const initSelectedAction = {
    action: '',
    command: '',
    name: '',
    text: '',
    payload: null
  };

  const [selectedActions, setSelectedActions] = useState([]);

  const enqueueAction = (item, txt) => {
    const items = [
      ...selectedActions,
      {
        ...initSelectedAction,
        action: item.button_value || item.action,
        command: item.command,
        payload: item.payload,
        name: item.name,
        text: txt || item.name
      }
    ];

    setSelectedActions(items);
  };

  const getActionByText = (actions, txt) =>
    actions.filter(item =>
      txt.toLowerCase().includes(item.text.replace(activeCommand, '').trim().toLowerCase())
    );

  const clearSelectedActions = () => setSelectedActions([]);

  return {
    selectedActions,
    setSelectedActions,
    enqueueAction,
    getActionByText,
    clearSelectedActions
  };
};

export default useActionInput;
